<template>
  <v-menu v-model="showCustomiseModal" offset-y :close-on-content-click="false">
    <v-flex
      slot="activator"
      shrink
      class="filter_item separator"
      style="cursor: pointer; background: #f0f6fa"
    >
      <v-layout>
        <v-icon size="16" color="#0277bd">filter_list</v-icon>
        <span class="heading">{{ workflowLabel(filtersCountMessage) }}</span>
        <div
          v-if="Object.keys(filtersWithValue).length !== 0"
          class="icon-close-container"
          @click.stop="resetFilters"
        >
          <v-icon size="16" color="#0277bd">close</v-icon>
        </div>
      </v-layout>
    </v-flex>
    <v-card v-if="showCustomiseModal" class="card">
      <v-layout column>
        <v-layout row justify-space-between>
          <span class="card-title">{{ adminText('workflowsAll.display_filters_356c0ed', 'Display filters') }}</span>
          <v-icon @click="showCustomiseModal = false">close</v-icon>
        </v-layout>
        <span class="card-subtitle">{{ adminText('workflowsAll.apply_filters_to_narrow_the_amount_of_diplaye_f34a406', 'Apply filters to narrow the amount of diplayed attendees.') }}</span>
        <form @submit.prevent="emitFilters">
          <filters-modal-form
            :attendee-fields="schema.attendeeFields"
            :initial-values="initialFilters"
            :categories="categories"
            :extra-modules="extraModules"
            @values="form = $event"
          />
          <div class="buttons-cotainer">
            <main-button
              class="remove-filters-button"
              :text="adminText('workflowsAll.remove_filters_1fa0c6e', 'Remove filters')"
              flat
              type="button"
              @click.stop="
                resetFilters()
                showCustomiseModal = !showCustomiseModal
              "
            />
            <main-button class="apply-button" :text="adminText('workflowsAll.apply_cfea419', 'Apply')" @click="$emit('submit')" />
          </div>
        </form>
      </v-layout>
    </v-card>
  </v-menu>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import FiltersModalForm from './filters-modal-form'

export default {
  mixins: [WorkflowDisplay],
  name: 'filters-modal',
  components: {
    FiltersModalForm,
  },
  props: {
    attendeeFields: Object,
    schema: Object,
    categories: Array,
    extraModules: Object,
    initialFilters: Object,
  },
  data() {
    return {
      showCustomiseModal: false,
      form: {},
    }
  },
  computed: {
    filtersCounter() {
      return Object.keys(this.filtersWithValue).length
    },
    filtersWithValue() {
      const { quickSearch, ...filters } = this.initialFilters

      return Object.entries(filters).filter(f => f[1])
    },
    filtersCountMessage() {
      if (this.filtersCounter === 0) {
        return this.adminText('workflowsAll.filters_c4614aa', 'Filters')
      } else if (this.filtersCounter === 1) {
        return this.adminText('workflowsAll.1_filter_eca49d9', '1 Filter')
      } else {
        return this.adminText('workflowsAll.count_filters_235f929', '{{count}} Filters', { count: this.filtersCounter })
      }
    },
  },
  methods: {
    resetFilters() {
      this.form = {}
      this.$router.replace({ query: {} }) // removes filters from url
      this.$emit('filtersChanged', this.form)
    },
    emitFilters() {
      this.$emit('filtersChanged', this.form)
      this.showCustomiseModal = false
    },
  },
}
</script>

<style scoped>
@media (min-width: 800px) {
  .separator {
    border-right: 2px solid white;
  }
}
.filter_item {
  padding: 14px 15px;
  text-transform: uppercase;
}
.filter_item:hover {
  background-color: rgba(2, 119, 189, 0.2);
}
.icon-close-container {
  border-radius: 50%;
  width: 19px;
  height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-close-container:hover {
  background-color: rgba(2, 119, 189, 0.2);
}
.v-menu__content {
  z-index: 11 !important;
}
.heading {
  color: #0277bd;
  font-size: 16px;
  font-family: 'Raleway', sans-serif;
  font-weight: bold;
  line-height: 1.25;
  margin-left: 6px;
  margin-right: 6px;
}
.card {
  margin-top: 8px;
  width: 430px;
  border-radius: 8px;
  padding: 16px 20px;
  max-height: 590px;
  overflow: auto;
}
@media (max-width: 800px) {
  .card {
    width: 100%;
  }
}
.card-title {
  color: #0277bd;
  font-size: 20px;
  font-family: 'Raleway', sans-serif;
  font-weight: bold;
  line-height: 24px;
  margin-bottom: 5px;
}
.card-subtitle {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem !important;
  line-height: 150%;
  color: #979797;
  margin-top: 0.75rem;
  margin-bottom: 1.5rem;
}
.apply-button {
  max-width: 80px;
  margin-top: 0px !important;
}
.remove-filters-button {
  margin-top: 0px !important;
}
.buttons-cotainer {
  display: flex;
  margin-top: 2.25rem;
  justify-content: flex-end;
}
</style>
